export default "__VITE_ASSET__ce43b98a__"